import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import {
  SurveysStore,
} from 'mobx-store/stores/surveysStore';
import {
  stores,
} from 'mobx-store';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import {
  translate,
} from '../../helperFunctions/translation';

interface IProps extends WithSnackbarProps {
  surveysStore: SurveysStore;
  history: any;
}

@inject('surveysStore')
@observer
class WifiPackagesScreen extends Component<IProps> {
  title: string = translate('surveyPageTitle');

  addButton: any;

  tableHeader: any = [];

  tableCellTypes: TableCellTypes[] = [];

  tableData: any[] = [];

  constructor(props: IProps) {
    super(props);
    this.addButton = this.getAddWifiPackagesButton();
    this.tableHeader = this.getWifiPackagesTableHeader();
    this.tableCellTypes = this.getWifiPackageTableCellTypes();
  }

  handleTableButtonCellClicked = (index: number, key: string) => {
    this.props.history.push(
      `/survey/${stores.surveysStore.surveysList[index].surveyId}/edit`,
    );
  };

  downloadReport = (index: number, key: string) => {
    stores.surveysStore.getSurveyReport(stores.surveysStore.surveysList[index].surveyId);
  };

  handelAdd = (): void => {
    this.props.history.push('/survey/new');
  };

  getAddWifiPackagesButton = () => ({
    title: translate('addButton'),
    onAdd: this.handelAdd,
  });

  getWifiPackagesTableHeader = () => [
    {
      title: translate('title'),
    },
    {
      title: translate('Status'),
    },
    {
      title: translate('editButton'),
    },
    {
      title: translate('downloadButton'),
    },
  ];

  getWifiPackagesTableData = () => stores.surveysStore.surveysList
    .map((survey) => ({
      ...survey, edit: translate('editButton'), downloadReport: translate('downloadButton'),
    }));

  getWifiPackageTableCellTypes = (): TableCellTypes[] => [
    {
      cellType: 'Text',
      key: 'title',
    },
    {
      cellType: 'ToggleButton',
      key: 'isActive',
      activeLabel: translate('FormActiveLabel'),
      inactiveLabel: translate('FormNotActiveLabel'),
      onChange: this.handleTableToggleCellChange,
    },
    {
      cellType: 'Button',
      key: 'edit',
      onClick: this.handleTableButtonCellClicked,
    },
    {
      cellType: 'Button',
      key: 'downloadReport',
      onClick: this.downloadReport,
    },
  ];

  componentDidMount() {
    stores.surveysStore.getSurveys();
  }

  handleTableToggleCellChange = (index: number, key: string, value: boolean) => {
    const survey = stores.surveysStore.surveysList[index];
    stores.surveysStore.updateSurvey(survey.surveyId, {
      isActive: value, title: survey.title, description: survey.description,
    }, stores.authStore.userData.countries)
      .then(async () => {
        SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage'), 8000, 'success');
        await stores.surveysStore.getSurveys();
      })
      .catch((error: any) => {
        console.log(error);
        SnackBarComponent.getInstance().openSnackbar(translate('errorMessage'), 8000, 'error');
      });
  };

  render() {
    this.tableData = this.getWifiPackagesTableData();
    return (
      <div>
        <GeneralTableComponent
          emptyMessage={translate('emptyTable')}
          title={this.title}
          tableHeader={this.tableHeader}
          tableData={this.tableData}
          tableCellTypes={this.tableCellTypes}
          addButton={this.addButton}
          loadingStatus={[
            stores.surveysStore.status,
          ]}
        />
      </div>
    );
  }
}

export default WifiPackagesScreen;
